<template>
    <v-col v-if="value != null" cols="12">
        <v-row align="center" class="my-2">
            <span class="text-normal ml-0 mr-4 pl-0 py-2" v-bind:class="{ 'text-capitalize' : $i18n.locale !== 'fr' }">{{ formatMenuText($t('account.profile')) }}</span>
            <v-divider></v-divider>
        </v-row>
        <v-row class="mb-2">
            <v-text-field v-model="value.Username"
                          id="fUsername"
                          :label="formatMenuText($t('account.username'))"
                          class="text-normal"
                          outlined hide-details
                          maxlength="50"
                          type="text"
                          :rules="disabled? [] : usernameRules"
                          :disabled="disabled"
                          @change="$emit('changed')"
                          @keydown.enter.prevent="$refs['firstName'].focus()" />
        </v-row>
        <v-row class="mb-2">
            <v-text-field v-model="value.FirstName"
                          id="firstName"
                          ref="firstName"
                          :label="formatMenuText($t('user-management.firstName'))"
                          class="text-normal"
                          outlined hide-details
                          maxlength="100"
                          type="text"
                          :rules="disabled? [] :firstnameRules"
                          :disabled="disabled"
                          @change="$emit('changed')"
                          @keydown.enter.prevent="$refs['lastName'].focus()" />

        </v-row>

        <v-row class="mb-0">
            <v-text-field v-model="value.LastName"
                          id="lastName"
                          ref="lastName"
                          :label="formatMenuText($t('user-management.lastName'))"
                          class="text-normal"
                          outlined hide-details
                          maxlength="100"
                          type="text"
                          :rules="disabled? [] :lastnameRules"
                          :disabled="disabled"
                          @change="$emit('changed')"
                          @keydown.enter.prevent="$refs['email'].focus()" />
        </v-row>
        <v-row class="mb-2 mt-0">
            <v-col>
                <v-row align="center" class="my-2">
                    <span class="text-normal ml-0 mr-4 pl-0 py-2">{{formatMenuText($t('account.communications'))}}</span>
                    <v-divider></v-divider>
                </v-row>
                <v-row>
                    <span class="ml-2 caption">{{formatMenuText($t('email'))}}</span>
                </v-row>
                <v-row class="mb-2 ml-2" align="center">
                    <span class="ml-2 text-normal">{{value.Email}}</span>
                    <v-tooltip bottom open-delay="1000">
                        <template v-slot:activator="{ on, attrs }">
                            <v-hover v-slot="{hover}">
                                <v-btn icon
                                       small
                                       :color="hover ? 'buttonHover' : ''"
                                       class="mx-1"
                                       v-bind="attrs"
                                       v-on="on"
                                       @click="onShowCommunicationDialog(0)"
                                       :aria-label="$t('edit') + ' ' + $t('email')">
                                    <v-icon aria-hidden="true">mdi-pencil-outline</v-icon>
                                </v-btn>
                            </v-hover>
                        </template>
                        <span>{{$t('edit')}}</span>
                    </v-tooltip>

                </v-row>
                <v-row v-if="value.Client.ActiveMFASMS">
                    <span class="ml-2 caption">{{formatMenuText($t('phoneNumber'))}}</span>
                </v-row>
                <v-row v-if="value.Client.ActiveMFASMS" class="mb-2 ml-2" align="center">
                    <template v-if="hasPhoneNumber">
                        <span class="ml-2 text-normal">{{displayPhoneNumber}}</span>
                        <v-tooltip bottom open-delay="1000">
                            <template v-slot:activator="{ on, attrs }">
                                <v-hover v-slot="{hover}">
                                    <v-btn icon
                                           small
                                           :color="hover ? 'buttonHover' : ''"
                                           class="mx-1"
                                           v-bind="attrs"
                                           v-on="on"
                                           @click="onShowCommunicationDialog(1)"
                                           :aria-label="$t('edit') + ' ' + $t('phoneNumber')">
                                        <v-icon aria-hidden="true">mdi-pencil-outline</v-icon>
                                    </v-btn>
                                </v-hover>
                            </template>
                            <span>{{$t('edit')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom open-delay="1000">
                            <template v-slot:activator="{ on, attrs }">
                                <v-hover v-slot="{hover}">
                                    <v-btn icon
                                           small
                                           :color="hover ? 'buttonHover' : ''"
                                           class="mx-1"
                                           v-bind="attrs"
                                           v-on="on"
                                           @click="showDeletePhoneDialog = true;"
                                           :aria-label="$t('remove') + ' ' + $t('phoneNumber')">
                                        <v-icon aria-hidden="true">mdi-close-circle-outline</v-icon>
                                    </v-btn>
                                </v-hover>
                            </template>
                            <span>{{$t('remove')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-hover v-slot="{hover}">
                            <v-btn :color="hover ? 'buttonHover' : 'primary'"
                                   text plain
                                   class="text-none"
                                   @click="onShowCommunicationDialog(1)">
                                <v-icon class="mr-1">mdi-plus</v-icon>
                                {{$t('addPhoneNumber')}}
                            </v-btn>
                        </v-hover>
                    </template>
                    <confirmation-dialog v-model="showDeletePhoneDialog"
                                         type="delete"
                                         :title="$t('user-settings.removePhoneNumberTitle')"
                                         :subtitle="$t('user-settings.removePhoneNumberText')"
                                         :btnOKText="$t('yes')"
                                         :persistent=true
                                         @commit="commitRemovePhoneNumber"
                                         @cancel="showDeletePhoneDialog = false" />
                </v-row>
                <v-row v-if="showCommunicationDialog">
                    <communicationDialog :value="communicationValue"
                                         :communicationType="communicationType"
                                         @commit="onCommunicationDialogCommit"
                                         @cancel="onCommunicationDialogCancel"></communicationDialog>
                </v-row>
                <v-row>
                    <span class="ml-2 caption">{{$t('language')}}</span>
                </v-row>
                <v-row class="ml-2">
                    <v-btn-toggle v-model="value.ContactLanguage"
                                  class="ma-2 mt-1"
                                  mandatory
                                  color="primary"
                                  @change="$emit('changed')">
                        <v-btn value="en">
                            EN
                        </v-btn>
                        <v-btn value="fr">
                            FR
                        </v-btn>
                    </v-btn-toggle>
                </v-row>
                <v-row v-if="value.Client.ActiveMFASMS">
                    <span class="ml-2 caption">{{$t('account.mfaPreference')}}</span>
                </v-row>
                <v-row v-if="value.Client.ActiveMFASMS" class="ml-2">
                    <v-btn-toggle v-model="value.MFAType"
                                  class="ma-2 mt-1"
                                  mandatory
                                  color="primary"
                                  @change="onMFATypeChange">
                        <v-btn value.number="0" 
                               :disabled="!hasPhoneNumber">
                            {{$t('email')}}
                        </v-btn>
                        <v-btn value.number="1"
                               :disabled="!hasPhoneNumber">
                            {{$t('sms')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-row>
            </v-col>
        </v-row>
    </v-col>
</template>
<script>
    import confirmationDialog from './confirmationDialog'
    import communicationDialog from './communicationDialog'
    export default {
        name: 'user-information',
        props: ['value', 'disabled'],
        components: { confirmationDialog, communicationDialog },
        data() {
            return {
                showDeletePhoneDialog: false,
                showCommunicationDialog: false,
                communicationValue: null,
                communicationType: 0,
                phoneNumberTemp: null,
                requiredRules: [
                    v => !!v || this.$t('requiredField')
                ],
                emailRules: [
                    v => !!v || this.$t('requiredField'),
                    v => (v && v.length >= 6 && v.length <= 256),
                    v => (v && String(v).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) != null),
                    v => (v && v.substring(0, v.indexOf("@")).length <= 64)
                ],
                usernameRules: [
                    v => !!v || this.$t('requiredField'),
                    v => (v && String(v).toLowerCase().match(/[^\w@.À-ú-]/gs) == null),
                    v => (v && v.length <= 50) || this.textLengthRule('username', 50)
                ],
                firstnameRules: [
                    v => !!v || this.$t('requiredField'),
                    v => (v && String(v).toLowerCase().match(/[^a-zA-Z0-9 'À-ú-]/gs) == null),
                    v => (v && v.length <= 255) || this.textLengthRule('firstname', 255)
                ],
                lastnameRules: [
                    v => !!v || this.$t('requiredField'),
                    v => (v && String(v).toLowerCase().match(/[^a-zA-Z0-9 'À-ú-]/gs) == null),
                    v => (v && v.length <= 255) || this.textLengthRule('lastname', 255)
                ],
            };
        },
        watch: {
            value(newVal) {
                this.phoneNumberTemp = newVal.PhoneNumber;
            }
            
        },
        computed: {
            displayPhoneNumber() {
                if (this.phoneNumberTemp == null || this.phoneNumberTemp.length != 12)
                    return this.phoneNumberTemp;
                else
                    return `(${this.phoneNumberTemp.substring(2, 5)}) ${this.phoneNumberTemp.substring(5, 8)}-${this.phoneNumberTemp.substring(8)}`;
            },
            hasPhoneNumber() {
                return (this.phoneNumberTemp != null && this.phoneNumberTemp.length > 0);
            },
        },
        // Le méthodes globales de l'application
        methods: {
            formatMenuText(text) {
                if (!text) return text;

                // Check the titleCase setting from the current experience
                const titleCase = this.$experience.titleCase !== false; // default to true if not set

                if (titleCase) {
                    // Title case: capitalize first letter of all words
                    return text.split(' ').map(word => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                } else {
                    // Sentence case: only capitalize first letter of first word
                    // But preserve acronyms
                    const words = text.split(' ');
                    return words.map((word, index) => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        if (index === 0) {
                            // First word: capitalize first letter
                            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                        } else {
                            // Other words: all lowercase
                            return word.toLowerCase();
                        }
                    }).join(' ');
                }
            },
            textLengthRule(fieldName, n) {
                return this.$t('textLengthRule', { field: this.$t(fieldName), n: n })
            },
            
            onMFATypeChange() {
                if (this.phoneNumberTemp == null && this.value.MFAType == 1)
                    this.phoneNumberError = true;
                else
                    this.phoneNumberError = false;

                this.$emit('phoneValidate', !this.phoneNumberError);
                this.$emit('changed');
            },
            commitRemovePhoneNumber() {
                this.showDeletePhoneDialog = false;
                this.phoneNumberTemp = null;
                this.value.PhoneNumber = null;
                this.value.MFAType = 0;
                this.$emit('changed');
            },
            onShowCommunicationDialog(communicationType) {
                try {
                    this.communicationType = communicationType;
                    this.communicationValue = communicationType == 0 ? this.value.Email : this.phoneNumberTemp;
                    this.showCommunicationDialog = true;
                } catch (ex) {
                    console.log(ex);
                }
                
            },
            onCommunicationDialogCommit(value) {
                this.showCommunicationDialog = false;
                if (this.communicationType == 0)
                    this.value.Email = value;
                else {
                    this.phoneNumberTemp = value;
                    this.value.PhoneNumber = value;
                }

                this.$emit('changed');
            },
            onCommunicationDialogCancel() {
                this.showCommunicationDialog = false;
            }
        }
    };
</script>
